import { render } from "./GunSvg.vue?vue&type=template&id=742b2997"
import script from "./GunSvg.vue?vue&type=script&lang=js"
export * from "./GunSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__